import React from "react";
import "./EraPage.css"; // Make sure it includes .industrial-banner etc.

function IndustrialRevolution() {
  return (
    <div className="era-page">
      {/* Banner */}
      <div className="era-banner industrial-banner">
        <h1>🏭 The Industrial Age: Gears, Steam & Change</h1>
        <p className="era-subtitle">Grade 6 - Industrial Age & Empires</p>
      </div>

      {/* Overview */}
      <section className="industrial-overview">
        <h2>⚙️ What Was the Industrial Revolution?</h2>
        <p>
          The Industrial Age was a time of big machines, busy factories, and amazing inventions.
          People moved to cities, worked in new jobs, and traveled on trains for the first time!
          Life changed faster than ever before.
        </p>
      </section>

      {/* Key Figures & Inventions */}
      <section className="industrial-key">
        <h2>🔧 Key People & Inventions</h2>
        <ul>
          <li>🚂 <strong>James Watt</strong>: Improved the steam engine that powered factories and trains.</li>
          <li>🧵 <strong>Spinning Jenny</strong>: A machine that made cloth much faster.</li>
          <li>💡 <strong>Thomas Edison</strong>: Brought the electric light bulb to life.</li>
          <li>🏙️ <strong>Factories</strong>: Large buildings where goods were made by workers and machines.</li>
        </ul>
      </section>

      {/* Comic-style Story */}
      <section className="industrial-story">
        <h2>📖 Mini Story: “Tilly's First Train Ride”</h2>
        <p>
          Tilly had never left her village. When the steam train arrived, she boarded with her father and
          watched the countryside zoom past. She held her hat as the whistle blew. It was the future—fast and loud!
        </p>
      </section>

      {/* Learning Video */}
      <section className="industrial-media">
        <h2>🎥 Learn by Watching</h2>
        <img
  className="industrial-illustration"
  src="/images/industrial-age-scene.png" // rename as you like
  alt="Illustration of a steam train, spinning jenny, Edison with a light bulb, busy factory, and children watching in awe"
  style={{ width: "100%", maxWidth: 500, borderRadius: "1.5rem", margin: "0 auto", boxShadow: "0 4px 24px rgba(0,0,0,0.12)" }}
/>
      </section>

      {/* Quiz or Challenge */}
      <section className="industrial-quiz">
        <h2>🧠 Quiz Time!</h2>
        <ol>
          <li>What did James Watt improve?</li>
          <li>What kind of buildings made goods?</li>
          <li>What invention gave us light indoors?</li>
        </ol>
        <p><em>(Review the answers with a friend or teacher!)</em></p>
      </section>

      {/* Timeline */}
      <section className="industrial-timeline">
        <h2>📅 Timeline of the Industrial Age</h2>
        <ul>
          <li>1765 – Watt improves the steam engine</li>
          <li>1780s – First factories appear in England</li>
          <li>1807 – First steamboat travels the Hudson River</li>
          <li>1879 – Edison invents the light bulb</li>
        </ul>
      </section>
    </div>
  );
}

export default IndustrialRevolution;
